export var valuesStepContentType = ["ContentString", "ContentMedia"];
/*

*/ 
//# sourceMappingURL=StepContentType.js.map